<div class="guidelines-dialog">
    <div class="dialog-head">
        <h2 class="dialog-title">{{ 'inputGuidelines' | translate }}</h2>
        <button type="button" class="dialog-close" (click)="onClose()" [attr.aria-label]="'close' | translate">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>
    </div>

    <div class="dialog-body">
        @for (item of guidelines; track item.labelKey) {
            <div class="guideline-item">
                <span class="guideline-label">{{ item.labelKey | translate }}</span>
                <span class="guideline-text">{{ item.textKey | translate }}</span>
            </div>
        }
    </div>

    <div class="dialog-actions">
        <button type="button" class="btn-close" (click)="onClose()">
            {{ 'close' | translate }}
        </button>
    </div>
</div>
